import trainerResult from '@/store/modules/trainer-result/trainer-result'
import trainerResultById from '@/store/modules/trainer-result/trainer-result-by-id'
import trainerResultCreate from '@/store/modules/trainer-result/trainer-result-create'
import trainerResultDelete from '@/store/modules/trainer-result/trainer-result-delete'
import trainerResultEdit from '@/store/modules/trainer-result/trainer-result-edit'
import rewardSearchList from '@/store/modules/trainer-result/reward-search-list'

export default {
  trainerResult,
  trainerResultById,
  trainerResultCreate,
  trainerResultDelete,
  trainerResultEdit,
  rewardSearchList,
}
